import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  name: {
    textTransform: "capitalize",
  },
}));

interface Props {
  name: string;
}

const UserName = ({ name }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Typography variant="body2" className={classes.name}>
      {name}
    </Typography>
  );
};

export default UserName;
